import { ILabel, RadioLabel, InputLabel } from '../modules/label';
import { setTimeout } from 'timers';

export function initializeHoverFocusEvents() {
    initializeRadioListeners();
    initializeInputListeners();
}

function initializeRadioListeners() {
    const radioLists: HTMLCollectionOf<Element> = document.getElementsByClassName('form-element-radio-list');

    for (let i = 0; i < radioLists.length; i++) {
        let tempList: Element = radioLists[i];
        let label: HTMLElement = tempList.querySelector('.form-element-label-main') as HTMLElement;
        let radioElements: HTMLCollectionOf<HTMLElement> = tempList.getElementsByClassName('form-element-radio') as HTMLCollectionOf<HTMLElement>;

        if (label) {
            let tempClass: ILabel = new RadioLabel(label, radioElements);
            tempClass.initializeListeners();
        }
    }
}

function initializeInputListeners() {
    setTimeout(() => {
        let inputCollection = document.getElementsByTagName('input');
        let selectCollection = document.getElementsByTagName('select');
        let spinnerArrows: HTMLCollectionOf<Element> = document.getElementsByClassName('spinner-arrow');

        var inputs;
        var selects;

        if (inputCollection && inputCollection.length > 0) {
            inputs = Array.prototype.slice.call(inputCollection);
        }

        if (selectCollection && selectCollection.length > 0) {
            selects = Array.prototype.slice.call(selectCollection);
            inputs = inputs.concat(selects);
        }

        [].forEach.call(spinnerArrows, arrow => { inputs.push(arrow) });

        for (let i = 0; i < inputs.length; i++) {
            let inputElement: HTMLElement = inputs[i] as HTMLElement;
            let label: HTMLElement = findLabel(inputElement);

            if (label) {
                let tempClass: ILabel = new InputLabel(label, inputElement);
                tempClass.initializeListeners();
            }
        }
    }, 2000)
}

/**
* Finds the label element associated with the input
*/
function findLabel(tempParent: HTMLElement) {
    while (tempParent.tagName !== "BODY") {
        tempParent = tempParent.parentElement;
        if (tempParent.classList && tempParent.classList.contains('form-element')) {
            let label: HTMLElement = tempParent.querySelector('.form-element-label-main') as HTMLElement;
            if (label) {
                return label;
            }
        }
    }
    return null;
}


